module.exports = __webpack_public_path__ + "static/media/sports (3).b8c0fb72.webp";